<script lang="ts" setup>
const dropdownsOpenState = useDropdowns()
const activeIndex = useState('activeIndex')
</script>
<template>
  <div
    class="menu-buttons z-index-20 flex-column ps-4 pe-4 py-1 p-md-0 m-pd-0 m-lg-0 flex-md-row flex-shrink-0 d-md-flex"
    :class="{
      'd-none': !dropdownsOpenState.menu || activeIndex,
      'd-flex': dropdownsOpenState.menu,
    }"
  >
    <WizardButton
      :title="$t('Vybaviť online')"
      wizard-api-url="/api/wizard/online-insurance"
      color="secondary"
      class="my-1 my-md-0 me-md-4"
    />

    <WizardButton
      :title="$t('Poistiť sa')"
      wizard-api-url="/api/wizard/self-insurance"
      color="primary"
      class="my-1 my-md-0"
    />
  </div>
</template>
<style scoped lang="scss">
@import './MenuButtons.scss';
</style>
